<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="600px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <AddForm ref="editForm" @reload="reload" @close="closeEditFormDialog" />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="$refs.editForm.save()">{{
          this.$l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import AddForm from '../add-form'

export default {
  mixins: [BaseTable],
  components: {PageMain, PageHeader, AddForm},
  data() {
    return {
      usePage: true,

      editFormDialogOptions: {
        visible: false,
        code: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzMoqListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog() {
      this.editFormDialogOptions = {
        visible: true,
        title: this.$l('dialog_title_moq_add') || '新增起定量',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    }
  },
}
</script>
